import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-modal';

import { DataContext } from '../../context/DataContext';
import { frecuenciaPagos, SAs } from '../../data/mochaData';
import http from '../../services/http';
import { sendNotificationPayByPhone } from '../../services/notifications';
import { calculatePrima } from '../../services/tarificar';
import { ImgAlert, ImgAlertCallCenter, ImgAlertOk, ImgFileDownload } from '../../svg';
import { customStyles, endPoints, monedas } from '../../utils/constanst';
import { twoDecimal } from '../../utils/helpers';

import DivRow from '../controls/DivRow';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';

import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import Pasarela from './Pasarela';

import ReCAPTCHA from "react-google-recaptcha";
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { planes } from '../../data/cotizadorCrData';

const Step9 = () => {

    const monedas = [{ value: 'U$', text: 'Dolares' }, { value: '¢', text: 'Colones' }]


    const { poliza, setPoliza, tarificacion, polizaChangeHandler } = useContext(CotizadorCRDataContext);

    const closePagoSuccessModal = () => { setPoliza({ ...poliza, showDialogPagoSuccess: false, showDialogConfirmAddress: true }); }

    const closeModalFinish = () => setPoliza({ ...poliza, showDialogFinish: false });

    const closeConfirmAddress = () => {
        setPoliza(prev => { return { ...prev, showDialogConfirmAddress: false } });

        if (poliza.aseguradoId != null && poliza.direccion != poliza.direccionCobro) {
            http(endPoints.updateEnteAddress(poliza.aseguradoId)).put({ id: poliza.aseguradoId, direccionCobro: poliza.direccionCobro });
        }
        openModalGracias();
    }

    const openModalGracias = () => setPoliza(prev => { return { ...prev, showDialogGracias: true } });
    const closeModalGracias = () => { setPoliza(prev => { return { ...prev, showDialogGracias: false } }); window.location.href = '/ProductosDigitales';; };

    const closeModalFaild = () => setPoliza({ ...poliza, faild: false });

  

const wichtTipoPago = value => {

    setPoliza({ ...poliza, tipPago: value });

}

useEffect(() => {

    const primaCalutated = calculatePrima(poliza.prima);

    const _prima = primaCalutated(poliza.frecuenciaPagos);

    setPoliza(current => ({
        ...current,
        direccionCobro: current.direccion,
        primeraCuota: twoDecimal(_prima),
        tipPago: false
    }));


}, [poliza.frecuenciaPagos]);

const onReCAPTCHAChange = (value) => {

    setPoliza(prev => ({
        ...prev,
        captcha: value,
        showCaptchaValidation: value == null
    }));
}

const getCurrencyProvider = () => {
    if (poliza.planId == planes.planDolares)
        return monedas.filter(x => x.value == 'U$');
    if (poliza.planId == planes.planColones)
        return monedas.filter(x => x.value == '¢');
}

const getCurerencySimbol = () => {
    return (poliza.planId === planes.planDolares) ? 'U$' : '¢';
}

const getAmount = () => {

    switch (poliza.frecuenciaPagos) {
        case '1'://Anual
            return poliza.primaAnual;
        case '2': //Semestral
            return poliza.primaSemestral;
        case '4': //Trimestral
            return poliza.primaTrimestral;
        case '12'://Mensual
            return poliza.primaMensual;
        default: return 0;
    }
}

const updatePasarelaData = (d) => {

    setPoliza({ ...poliza, pasarela: { ...d } });
}

return (
    <div>

        <div className="reponsive">
            <div className='reponsive-width-6'>
                <div className='box-pl2-pr2'>
                    {/* <InputSelect label='Suma asegurada contratada' field='sa' value={poliza.sa} dataProvider={SAs} onChange={polizaChangeHandler} textFormatter={(item) => `$ ${item.text}`} /> */}
                    <Input
                        label='Suma asegurada contratada'
                        field='suma'
                        value={`${getCurerencySimbol()} ${twoDecimal(tarificacion.suma)}`}
                    />

                    <InputSelect label='Frecuencia de pago' field='frecuenciaPagos' value={poliza.frecuenciaPagos} dataProvider={frecuenciaPagos} onChange={polizaChangeHandler} readOnly={true} />

                    <DropDownInput
                        valueReadOnly={true}
                        label='Cuota a Pagar'
                        dataProvider={getCurrencyProvider}
                        value={getAmount()}
                        valueSelect='U$'
                        type='number'
                    />
                </div>


                <div className='box-pl2-pr2 mt-25'>
                    <ReCAPTCHA onChange={onReCAPTCHAChange} sitekey='6Lfsl0UfAAAAAACaOD7IEP__fbkyPddWTFz1Z1sn' required={true} />
                    {
                        poliza.showCaptchaValidation &&
                        <span style={{ color: 'red' }} >Seleccione la casilla no soy un robot</span>
                    }

                </div>
            </div>
            <div width='reponsive-width-6'>
                <Pasarela datosPasarela={poliza.pasarela} actualizarDatosPasarela={updatePasarelaData} />
            </div>
        </div>
        <div className="new-div reponsive">
            <div className='reponsive-width-12'>

            </div>
        </div>


        <Modal
            isOpen={poliza.showDialogPagoSuccess}
            onRequestClose={closePagoSuccessModal}
            style={customStyles}
            shouldCloseOnOverlayClick={false}
            contentLabel="Example Modal"
        >
            <div className="dialog-center-content">
                <p>!Muchas gracias por su compra¡</p>
            </div>
            <div className="dialog-center-content">
                <p>Su pago fue un éxito</p>
            </div>
            <div className="dialog-center-content">
                <ImgAlertOk />
            </div>
            <div className="dialog-center-content">
                <p>Referencia: <b>{poliza.reference}</b></p>
            </div>
            <div className="dialog-center-content">
                <p>Póliza: <b>{poliza.cnpoliza}</b></p>
            </div>
            <h3 className="txt-primary">Estimado cliente, debe contestar a cada una de las preguntas antes de continuar</h3>
            <div className="dialog-center-content">
                <button type="button" className="control-button-btn btn-color-primary" onClick={closePagoSuccessModal}>Entendido</button>
            </div>
        </Modal>

        <Modal
            isOpen={poliza.showDialogConfirmAddress}
            onRequestClose={closeConfirmAddress}
            style={customStyles}
            shouldCloseOnOverlayClick={false}
            contentLabel="Example Modal"
        >
            <div className="dialog-center-content">
                <h2 className="txt-primary">Confirme su método de envío</h2>

            </div>

            <Input type="textarea" label='Confirme la dirección a la cual desea su envío' field='direccionCobro' value={poliza.direccionCobro} onChange={polizaChangeHandler} />
            <br />
            <div className="dialog-center-content">
                <button type="button" className="control-button-btn btn-color-primary" onClick={closeConfirmAddress}>Confirmar</button>
            </div>
        </Modal>

        <Modal
            isOpen={poliza.showDialogFinish}
            onRequestClose={closeModalFinish}
            style={customStyles}
            shouldCloseOnOverlayClick={false}

        >
            {poliza.creating === true && <div className="dialog-center-content">
                <p className="text-center">Cargando...</p>
            </div>}
            {poliza.creating === false &&
                <div>
                    <div className="dialog-center-content">
                        <p className="text-center txt-primary txt-ft-18">Esta a un paso de su nueva póliza</p>
                    </div>
                    <div className="dialog-center-content">
                        <ImgAlertCallCenter />
                    </div>
                    <div className="dialog-center-content">
                        <p className="text-center txt-muted txt-ft-12">Ahora que he compleado el formulario para la adquisición de su poliza, un ejecutivo de Seguros LAFISE le llamara para continuar con el proceso de pago, le recordamos tener a mano su tarjeta</p>
                    </div>
                    <div className="mt-50"></div>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={() => window.location.href = '/ProductosDigitales'}>Finalizar</button>
                    </div>
                </div>
            }
        </Modal>
        <Modal
            isOpen={poliza.faild}
            style={customStyles}
            shouldCloseOnOverlayClick={false}
            contentLabel="Example Modal"
        >
            <h2 className="txt-primary txt-center">
                Error al procesar el pago
            </h2>
            <div className="dialog-center-content">
                <ImgAlert />
            </div>
            <h5 className="txt-muted">Ha ocurrido un error al procesar el pago, por favor intente la opcion de pago para que un ejecutivo se ponga en contacto con ud</h5>
            <div className="dialog-center-content">
                <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalFaild}>Entendido</button>
            </div>
        </Modal>

        <Modal
            isOpen={poliza.showDialogGracias}
            onRequestClose={closeModalGracias}
            style={customStyles}
            shouldCloseOnOverlayClick={false}
            contentLabel="Example Modal"
        >
            <div className="dialog-center-content">
                <div className="fontsize14" style={{ 'padding-left': 50, 'padding-right': 50 }}>
                    <h3 className="h3 lfesm text-center">¡Gracias por confiar en seguro LAFISE!</h3>

                    <div className="dialog-center-content">
                        <ImgFileDownload />
                    </div>
                    <p>
                        Te llamaremos para coordinar la entrega de póliza; envío solo aplica a la ciudad/municipio de Managua, resto del país debe retirar en cualquier sucursal de Banco LAFISE Bancentro
                    </p>

                </div>
            </div>

            <div className="dialog-center-content">
                <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalGracias}>Finalizar</button>
            </div>
        </Modal>

    </div>
);
}

export default Step9;
